import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { StopGuessing } from "./components/sections/StopGuessing";
import { WhatYouReceive } from "./components/sections/WhatYouReceive";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { RealProblem } from "./components/sections/RealProblem";
import { SoundFamiliar } from "./components/sections/SoundFamiliar";
import { Volumes } from "./components/sections/Volumes";
import { Bonuses } from "./components/sections/Bonuses";
import { Testimonials } from "./components/sections/Testimonials";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { WhatMakesDifferent } from "./components/sections/WhatMakesDifferent";
import { Author } from "./components/sections/Author";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Disclaimer } from "./components/sections/Disclaimer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="3rbrakqf99zft">
      <MetaPixel data-id="element-1" data-mp="5ott78p769p" />
      <Hero data-id="element-2" data-mp="67yvnd9206b" />
      <main data-id="element-3" data-mp="4wyzymxdckh">
        <StopGuessing data-id="element-4" data-mp="5gfdawxfswe" />
        <WhatYouReceive data-id="element-5" data-mp="82ovg3doih9" />
        <BeforeAfter data-id="element-6" data-mp="2zld2jatxbhc2" />
        <RealProblem data-id="element-7" data-mp="2zlv32jnmchps" />
        <SoundFamiliar data-id="element-8" data-mp="2zmo4d53t6f0j" />
        <Volumes data-id="element-9" data-mp="2zn678kkz7rhf" />
        <Bonuses data-id="element-10" data-mp="33moqzd129wio" />
        <Testimonials data-id="element-11" data-mp="33m5e4aq9pybi" />
        <Offer data-id="element-12" data-mp="33nggc642ey0i" />
        <Guarantee data-id="element-13" data-mp="33mymth8sexwa" />
        <WhatMakesDifferent data-id="element-14" data-mp="33oi1j3esp0vy" />
        <Author data-id="element-15" data-mp="38l8gtoirzsgb" />
        <Faq data-id="element-16" data-mp="38kqb81a841vq" />
        <FinalCta data-id="element-17" data-mp="38k6tolohjfi8" />
      </main>
      <Disclaimer data-id="element-18" data-mp="38o4gpie6or7e" />
      <FloatingCta data-id="element-19" data-mp="3dkl58dpap7l0" />
      <PurchasePopup data-id="element-20" data-mp="3dl4kfmnk9hvc" />
    </div>;
}